import React, { useState, useEffect } from "react";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import "./about.css";
import axios from "axios";

const Aboutus = () => {
  const [principal, setPrincipal] = useState(null);

  useEffect(() => {
    fetchPrincipalData();
  }, []);

  const fetchPrincipalData = async () => {
    try {
      const response = await axios.get(
        "https://gptkpm.in/backend/admin/principal.php"
      );
      setPrincipal(response.data);
    } catch (error) {
      console.error("Error fetching principal data:", error);
    }
  };

  return (
    <div className="main-top">
      <Header />
      <div className="p-1">
        <div className="p-right">
          <div>
            <h3 className="hading">Vision:</h3>
            <p>
              To emanate as a leading institution in education to develop
              engineering professionals who are technically competent, ethical,
              and environmentally friendly for the betterment of society.
            </p>
          </div>
          <div>
            <h3 className="hading">Mission:</h3>
            <p>
              To develop competent engineering professionals through high-quality
              academic instructions and industry collaborations to face emerging
              challenges with credibility, integrity, ethics, and social concern.
            </p>
          </div>
        </div>
      </div>
      <div className="p-2">
        <h2 className="hading">About the Institution</h2>
        <p>
          Dr. Y.C. James Yen Government Rural Polytechnic, Kuppam is the First
          Technical Institution located in an impressive picturesque and serene
          atmosphere at Kuppam, Chittoor Dt., a Tri-junction of Andhra Pradesh,
          Tamil Nadu, and Karnataka States.
        </p>
        <p>
          The Institution is established, sponsored, and managed by the Kuppam
          Rural Electric Co-operative Society Limited, (K.R.E.C.S.Ltd.,) Kuppam,
          a Govt. of India undertaking in 1998. This is the only Technical
          Institution in the entire State of Andhra Pradesh, functioning under
          the Co-operative Sector with financial contribution from the Govt. of
          Andhra Pradesh and the K.R.E.C.S. Ltd., Kuppam. It is approved by the
          A.I.C.T.E. New Delhi and Affiliated to S.B.T.E.T., Hyderabad, A.P. It
          is a Co-education Institute. Later, The institution has been taken over
          by the Government w.e.f. 28.3.2014, and the details of the institution
          have been depicted as prior to taken over and after taken over by the
          Government all the benefits are reaching the poor and downtrodden
          students of this institution.
        </p>
        <p>
          INFRASTRUCTURE: The Administrative and Academic blocks, hostel
          buildings, and Playgrounds are constructed in an extent of 25 acres of
          land. The Institution has high standards of Institutional and
          Residential facilities. It is provided with well-equipped Workshops and
          Laboratories. The Classrooms are spacious and well-ventilated. The
          Library is well maintained with a vast collection of Texts, Reference
          books, journals, periodicals, Magazines, etc. The hostel for boys is
          located in a serene environment within the campus with all the
          amenities. Traditional classroom teaching is supplemented by e-learning
          classrooms in each of the branches. In the recent past, with the
          initiative provided by the Special Commissioner of Technical Education,
          Andhra Pradesh, Vijayawada, a digital virtual classroom has been
          established to get the best of the teaching inputs across the entire
          state of Andhra Pradesh.
        </p>
        <p>
          Programmes offered:
          <br /> <br />
          DIPLOMA IN COMPUTER ENGINEERING 30+3(EWS)
          <br /> <br />
          DIPLOMA IN ELECTRONICS & COMMUNICATION ENGINEERING 60+6(EWS)
          <br /> <br />
          DIPLOMA IN ELECTRICAL & ELECTRONICS ENGINEERING 60+6(EWS)
          <br /> <br />
          DIPLOMA IN MECHANICAL ENGINEERING 60+6(EWS)
        </p>
      </div>
      <div className="p-3">
        <h2 className="hading">Alumni</h2>
        <ul>
          <p style={{ marginBottom: "20px", color: "gray" }}>OBJECTIVES:</p>
          <li>
            To serve as a forum to promote and foster relationships among the
            alumni, the present students, the staff, and the management of
            Dr.Y.C.James Yen Govt Polytechnic.
          </li>
          <li>
            To help the Alma mater in its effort to achieve excellence in
            technical and professional education.
          </li>
          <li>
            To actively and constructively participate in the well-being of the
            Dr.Y.C.James Yen Govt Polytechnic, by utilizing the goodwill, rich
            experience, and services of the alumni who are a fraternity of
            professional engineers of various disciplines spread all over the
            world.
          </li>
          <li>
            To institute scholarships, revolving loan funds, prizes/medals, etc.,
            for the deserving students of Dr.Y.C.James Yen Govt Polytechnic.
          </li>
          <li>
            To maintain continuous interaction between the past and present
            students by publishing a newsletter, holding periodical Alumni day
            celebrations, or by any other means as decided by the association.
          </li>
          <li>
            To contribute towards improving entrepreneurship development
            activities, campus placements, library, and centers of excellence at
            Dr.Y.C.James Yen Govt Polytechnic.
          </li>
          <li>
            To arrange lectures by eminent Alumni and other eminent personalities
            for the benefit of students and alumni.
          </li>
        </ul>
      </div>
      <ul className="p-4">
        <h2 className="hading">Goals</h2>
        <li>To get a good brand name for the Institute.</li>
        <li>To organize skill enhancement programs and national level contests, in association with CSI, IEEE, etc.</li>
        <li>To strengthen industry-institute interaction.</li>
        <li>To develop centers of excellence in technical collaboration with software giants like Microsoft, CISCO, IBM & Infosys, etc.</li>
      </ul>
      <div className="p-4">
        <h2 className="hading">Hallmarks</h2>
        <p style={{ color: "gray", margin: "20px 0" }}>
          The Merit awards are given in recognition of the students' efforts in striving to achieve excellence. The employees are also inspired to contribute by way of recognizing their efforts in academics. Special Prizes are given for 100% attendance maintenance.
        </p>
        <ul style={{ listStyleType: "none", padding: 0 }}>
          <li>NIPUNYA</li>
          <li>SWAGATH</li>
          <li>WORLD ROBOTICS</li>
          <li>PRATHIBA</li>
        </ul>
        <h2 style={{ color: "black", margin: "20px 0", textDecoration: "underline", color: "#ff6600" }}>
          Achievements by students and faculty – Eyantra Robotics Lab
        </h2>
        <p style={{ color: "gray", margin: "20px 0" }}>
          Eligible for Class A Awards with cash prize and Completion Certificates
        </p>
        <ul style={{ listStyleType: "none", padding: 0 }}>
          <li>Apollo Institute of Engineering & Technology, Enasan, Gujarat</li>
          <li>B. K. Birla College of Arts, Science & Commerce (Autonomous), Kalyan, Thane, Maharashtra</li>
          <li>Dr. Y C James Yen Government Polytechnic, Andhra Pradesh</li>
          <li>Hindusthan Institute of Technology, Coimbatore, Tamil Nadu</li>
          <li>Indian Institute of Technology, Bombay, Mumbai, Maharashtra</li>
        </ul>
      </div>

      <div className="prince">
        {principal ? (
          <div style={{ display: "flex", justifyContent: "start", flexDirection: "column", alignItems: "flex-start", color: "gray" }}>
            <h2 className="hading">Principal's Message</h2>
            {principal.image && (
              <div
                style={{
                  backgroundImage: `url(data:image/jpeg;base64,${principal.image})`,
                  width: "200px",
                  height: "200px",
                  backgroundSize: "cover",
                  margin: "20px 0",
                }}
              ></div>
            )}
            <div>
              <h3>{principal.name}</h3>
              <p>Education: {principal.education}</p>
              <p>Profession: {principal.profession}</p>
              <p>
                Dr.Y.C.James Yen Government Polytechnic, Kuppam, which was established in the year 1998, has been playing a vital role since its inception in producing world-class engineers required to meet the demands of the fast-changing global world. We have been consistently ranked as one of the top institutes in the State. Our primary objective is to provide quality education through long-term value creation. As one of the top technical institutes in the State, we offer 4 AICTE-approved diploma programs, with more than 500 students and over 30 well-qualified faculty members, and we have been extending committed efforts to provide quality education. The curriculum is being redesigned frequently to keep pace with the emerging demands of the industry.
              </p>
              <p>
                Dr.Y.C.James Yen Government Polytechnic, Kuppam, is committed to achieving excellence in technical education and research, and the assessment of the success of its programs is done using the highest standards of quality, innovation, and visibility. The core values of discipline, integrity, trust, holistic learning, ethics, professionalism, and concern for society and the environment are all closely interwoven into the fabric of our academic programs.
              </p>
              <p>
                Since the institute's inception, the institution has a rich history of producing capable engineers and, in general, influential and confident individuals. The alumni have made Dr.Y.C.James Yen Government Polytechnic, Kuppam proud by contributing significantly to building our nation.
              </p>
            </div>
          </div>
        ) : (
          <p>Loading principal details...</p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Aboutus;
